import React from 'react';
import { useParams } from 'react-router-dom';
import "./Faculty.css";    

const FacultyDetails = () => {
  const { facultyName } = useParams();

  const facultyDetails = {
    "reena-kaushik": {
      name: " Ms. Dr. Reena Kaushik",
      designation: "Principal",
      qualification: ["M.Pharm (Pharmaceuticals), Ph.D.",
        "M.Sc (Chemistry), M.Tech (Computer Science and Engineering)",
      ],
      experience: [
        "11 yearss of experience in teaching and Industry research",
        "Teaching: HSRT, Panchkula (2007-2007)",
        "Clinical: Bhagwat Day Health Sciences, Rohtak (2007-2012)",
        "Research: Ongoing (2012-Present)"
      ],
      Specialization: "Pharmaceuticals",
      image: "/facultyimage/WhatsApp Image 2025-02-12 at 10.31.59.jpeg" 
    },
    "divya-kaushik": {
      name: "Ms. Divya Kaushik",
      designation: "Assistant Professor",
      qualification: "M.Pharma(Pharmaceutics)",
      experience: [
        "3 years of experience in teaching.",
         ],
      image: "/facultyimage/School of pharmacy .jpg",
      Specialization: "B.Pharma",
    },
    "pragati-singh": {
      name: "Mr. Pragati Singh",
      designation: "Lecturer",
      qualification: "B.Pharmacy (Uttar Pradesh Technical University)",
      experience: [
        "5 years Experience in Teaching",
        
      ],
      Specialization: "Pharmacology",
      image: "/facultyimage/Screenshot_20250219-132728.png "  
    },
    "mohan-shyam": {
      name: "Mr. Mohan Shyam",
      designation: "Lecturer",
      qualification: "B.Pharmacy ",
      experience: [
        "3 years Experience in Teaching",
      ],
      Specialization: "Pharmacognosy ",
      image: "/facultyimage/mohan-shyam.jpeg"  
    },
    "brijesh": {
      name: "Mr. Brijesh",
      designation: "Lecturer",
      qualification: "B.Pharmacy",
      experience: [
        "5 years Experience in Teaching ",
      
      ],
      Specialization: "Pharmaceuticals in chemistry",
      image: "/facultyimage/WhatsApp Image 2025-02-19 at 13.36.37.jpeg" 
    }
  };

  const faculty = facultyDetails[facultyName];

  if (!faculty) {
    return <h2>Faculty not found</h2>;
  }

  return (
    <div className='faculty-details-container'>
      <div className='faculty-details-image'>
        <img src={faculty.image} alt={faculty.name} /> 
      </div>
      <div className='faculty-details-text'>
        <h2>{faculty.name}</h2>
        <h3>{faculty.designation}</h3>
        <p><strong>Qualification:</strong> {faculty.qualification}</p>
        <p><strong>Specialization:</strong> {faculty.Specialization}</p>
        <h3>Experience:</h3>
        <ul>
          {faculty.experience.map((item, index) => (
            <li key={index}>{item}</li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default FacultyDetails;

